let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aVX51")).then(() => parcelRequire('5fONF'));